import StudentRecordDrawer from "src/grading/components/StudentRecordDrawer/StudentRecordDrawer";
import { RosterStudent } from "src/models";

interface Props {
  student: RosterStudent | null;
  classId: string;
  /** Class shown under the student's name in the drawer. */
  classLabel: string;
  /** Teacher and school-admin read access to the plan and health note. */
  canViewHealth: boolean;
  canEdit: boolean;
  /** Fields the roster owns for this student (`StudentDetail.readOnlyFields`), once loaded. */
  readOnlyFields?: string[];
  onClose: () => void;
}

/**
 * Accommodation plan for one student (FR-047), shown in the student record drawer: the planned
 * level on the official ladder, the alternative event, health flags and notes. The plan and
 * health note render only for teacher and school-admin roles; never for scorers.
 */
const AccommodationsPanel = ({
  student,
  classId,
  classLabel,
  canViewHealth,
  canEdit,
  readOnlyFields,
  onClose,
}: Props) => (
  <StudentRecordDrawer
    open={!!student}
    onClose={onClose}
    student={student}
    classId={classId}
    classLabel={classLabel}
    canViewHealth={canViewHealth}
    canEdit={canEdit}
    readOnlyFields={readOnlyFields}
  />
);

export default AccommodationsPanel;
